import { createSlice } from "@reduxjs/toolkit";
import { getAuthUser } from "../../utils";

const initialState = getAuthUser();

const userSlice = createSlice({
    initialState,
    name: "user",
    reducers: {
        login: (state, action) => action.payload,

        logout: (state, action) => {
            return false
        },
        setIsCephUser: (state, action) => {
            state.is_ceph_user = action.payload;
            return state
        }
    }
})

export default userSlice.reducer;

export const {
    login, logout, setIsCephUser
} = userSlice.actions;
